import React from 'react';

function Intro() {
  return (
    <section className="intro section-padding">
      <div className="container">
        <div className="row lg-marg">
          <div className="col-lg-8 md-mb80">
            <div className="row lg-marg align-items-center">
              <div className="col-md-6">
                <div className="img1 sm-mb50">
                  <img src="/assets/imgs/zonya/photoshoot/michaljirik.webp" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="text">
                  <h3 className="mb-30">
                    We don't build projects, {' '}
                    <span className="fw-300">we build</span>{' '}
                    <span className="fw-300">partnerships.</span>
                  </h3>
                  <p>
                    We are not a website factory – We are your technology partners. Every line of code we write is tailored to your vision, your people, and your goals.
                  </p>

                  {/* <a href="/page-about" className="underline main-color mt-40">
                    <span className="text">
                      More About Us <i className="ti-arrow-top-right"></i>
                    </span>
                  </a> */}
                </div>
              </div>
            </div>
            <div className="numbers mt-80">
              <div className="row lg-marg">
                <div className="col-md-6">
                  <div className="item bord-thin-top pt-30 d-flex align-items-end mt-20">
                    <div>
                      <h4 className="fw-300 mb-10">Analysis without manuals</h4>
                      <h6 className="p-color sub-title"> Individual approach to all your needs.</h6>
                    </div>
                    {/* <div className="ml-auto">
                      <div className="icon-img-40">
                        <img src="/assets/imgs/arw0.png" alt="" />
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="item bord-thin-top pt-30 d-flex align-items-end mt-20">
                    <div>
                      <h4 className="fw-300 mb-10">Straight to the point</h4>
                      <h6 className="p-color sub-title">We deal with things straightforwardly, without unnecessary fuss.</h6>
                    </div>
                    {/* <div className="ml-auto">
                      <div className="icon-img-40">
                        <img src="/assets/imgs/arw0.png" alt="" />
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="img-full fit-img">
              <img src="/assets/imgs/zonya/photoshoot/dayojirik.webp" alt="" />
              {/* <img src="/assets/imgs/Zonya/photoshoot/corpo3.jpg" alt="" /> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
